import React, { useState } from "react";
import {
  View,
  Flex,
  SwitchField,
  Heading,
  SelectField,
  Text,
} from "@aws-amplify/ui-react";
import { insertDataToPatientDB } from "./DataFetcher";
import { config } from "./config"; // 加载配置

const PatientDataPage = ({
  patientData,
  setPatientData,
  setData,
  clinicName,
}) => {
  const [growthHormoneNumberDisabled, setGrowthHormoneNumberDisabled] =
    useState(!patientData.data[patientData.currentDate]?.growthHormone ?? true);
  const [omnitropNumberDisabled, setOmnitropNumberDisabled] = useState(
    !patientData.data[patientData.currentDate]?.omnitrop ?? true
  );
  const [bloodTestTypeDisabled, setBloodTestTypeDisabled] = useState(
    !patientData.data[patientData.currentDate]?.bloodTest ?? true
  );
  const handleSubmit = async (event, patientData) => {
    event.preventDefault();
    console.log("handleSubmit");
    const confirm = await window.confirm(`確定要寫入資料嗎
      `);
    if (!confirm) {
      return;
    }
    const basicInfoFields = [
      "name",
      "birthday",
      "email",
      "phone",
      "ID",
      "gender",
      "referral",
      "residence",
    ];

    // 将基本资料存储到patientData中
    basicInfoFields.forEach((field) => {
      const element = event.target.elements[field];
      if (element) {
        patientData[field] = element.value;
      }
    });

    // 确保patientData.data和patientData.data[patientData.currentDate]存在
    if (!patientData.data) {
      patientData.data = {};
    }
    if (!patientData.data[patientData.currentDate]) {
      patientData.data[patientData.currentDate] = {};
    }

    // 获取门诊记录的数据
    const clinicRecordFields = [
      "arrived",
      "doctorInfo",
      "boneAge",
      "daflon",
      "daflon4W",
      "leuplin12W",
      "growthHormone",
      "growthHormoneNumber",
      "omnitrop",
      "omnitropNumber",
      "bloodTest",
      "bloodTestType",
      "ultrasoundForPelvis",
    ];

    // 将门诊记录数据存储到patientData.data[patientData.currentDate]中
    clinicRecordFields.forEach((field) => {
      const element = event.target.elements[field];
      if (element) {
        if (element.type === "checkbox") {
          patientData.data[patientData.currentDate][field] = element.checked;
        } else {
          patientData.data[patientData.currentDate][field] = element.value;
        }
      }
    });

    console.log("更新后的patientData:", patientData);

    if (patientData.first) {
      patientData.createTime = await config.getTaipeiTimeString();
    }

    patientData.lastModifyDate = await config.getTaipeiTimeString();
    // 如果是初診，且當天未報到，則將first設為true， 其他情況則為false
    patientData.first = patientData.data[patientData.currentDate].arrived
      ? false
      : patientData.first;
    // setPatientData({
    //   ...patientData,
    //   first: patientData.data[patientData.currentDate].notArrived
    //     ? patientData.first
    //     : false,
    // });
    let result = await insertDataToPatientDB(patientData);
    if (result) {
      window.alert("已經成功寫入複診資料庫");
      // 檢查是否有暫存資料的cookie
      let tempSave = document.cookie
        .split(";")
        .find((row) => row.trim().startsWith("tempSave="));
      let tempSaveData = {};
      if (
        !tempSave ||
        (tempSave &&
          JSON.parse(tempSave.split("=")[1]).date !==
            (await config.gettodayymd()))
      ) {
        // 如果沒有tempSave cookie,則創建一個包含今天日期的JSON對象
        tempSaveData = {
          date: await config.gettodayymd(),
          [patientData.ID]: "",
        };
        // 設置cookie有效期為1天
      } else {
        // 如果tempSave cookie存在,則更新cookie
        tempSaveData = JSON.parse(tempSave.split("=")[1]);
        tempSaveData[patientData.ID] = "";
        document.cookie = `tempSave=${JSON.stringify(tempSaveData)}; path=/`;
      }
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      document.cookie = `tempSave=${JSON.stringify(
        tempSaveData
      )}; expires=${tomorrow.toUTCString()}; path=/`;
      setPatientData({
        ...patientData,
      });
    } else {
      setData(false);
    }
  };
  const handlPatientInfo = (event) => {
    const { id, type, value, checked } = event.target;
    let newValue = type === "checkbox" ? checked : value;
    if (id === "first") {
      newValue = newValue === "初診"; // 修正为赋值
    }
    console.log(id, newValue);
    setPatientData({
      ...patientData,
      [id]: newValue,
    });
  };

  console.log("patientData", patientData);
  return (
    <Flex direction="row">
      {/* 左侧部分，占 30% */}

      {/* <Heading level={2}>左侧部分</Heading> */}
      <form
        onSubmit={(event) => handleSubmit(event, patientData)}
        style={{ display: "flex", flexDirection: "row", gap: "10px" }}
      >
        <div style={{ display: "flex", alignItems: "stretch" }}>
          <View width="30%" backgroundColor="#f0f0f0" padding="20px">
            <div>
              <Heading level={2}>基本資料</Heading>
              <label htmlFor="first">初診/復診:</label>
              <SelectField
                id="first"
                options={["初診", "複診"]}
                defaultValue={patientData.first ? "初診" : "複診"}
                style={{ flexGrow: 1 }}
                onChange={handlPatientInfo}
              />
              <label htmlFor="clinic">clinic:</label>
              <input
                type="text"
                id="clinic"
                value={patientData.clinic}
                onChange={handlPatientInfo}
              />

              <label htmlFor="name">name:</label>
              <input
                type="text"
                id="name"
                value={patientData.name}
                onChange={handlPatientInfo}
              />
              <label htmlFor="birthday">birthday :</label>
              <input
                type="text"
                id="birthday"
                value={patientData.birthday}
                onChange={handlPatientInfo}
              />
              <label htmlFor="email">email :</label>
              <input
                type="text"
                id="email"
                value={patientData.email}
                onChange={handlPatientInfo}
              />
              <label htmlFor="phone">phone :</label>
              <input
                type="text"
                id="phone"
                value={patientData.phone}
                onChange={handlPatientInfo}
              />
              <label htmlFor="ID">ID :</label>
              <input
                type="text"
                id="ID"
                value={patientData.ID}
                onChange={handlPatientInfo}
              />
              <label htmlFor="gender">gender :</label>
              <input
                type="text"
                id="gender"
                value={patientData.gender}
                onChange={handlPatientInfo}
              />
              <label htmlFor="referral">如何知道本專科門診:</label>
              <select
                id="referral"
                value={patientData?.referral}
                onChange={handlPatientInfo}
              >
                <option value="">請選擇</option>
                <option value="之前看過李醫師">之前看過李醫師</option>
                <option value="親友介紹">親友介紹</option>
                <option value="Google搜尋">Google搜尋</option>
                <option value="李醫師FB粉專">李醫師FB粉專</option>
                <option value="李醫師IG粉專">李醫師IG粉專</option>
                <option value="診所粉專">診所粉專</option>
                <option value="本診所其他醫師轉介">本診所其他醫師轉介</option>
                <option value="診所簡訊通知">診所簡訊通知</option>
                <option value="本診所文宣(如影片、小卡等)">
                  本診所文宣(如影片、小卡等)
                </option>
                <option value="其他">其他</option>
              </select>

              <label htmlFor="residence">居住區域:</label>
              <select
                id="residence"
                value={patientData.residence}
                onChange={handlPatientInfo}
              >
                <option value="">請選擇</option>
                <option value="台北市">台北市</option>
                <option value="板橋區">板橋區</option>
                <option value="土城區">土城區</option>
                <option value="中和區">中和區</option>
                <option value="永和區">永和區</option>
                <option value="樹林區">樹林區</option>
                <option value="新莊區">新莊區</option>
                <option value="泰山區">泰山區</option>
                <option value="蘆洲區">蘆洲區</option>
                <option value="三重區">三重區</option>
                <option value="林口區">林口區</option>
                <option value="桃園市">桃園市</option>
                <option value="基隆市">基隆市</option>
                <option value="其他">其他</option>
              </select>
            </div>
          </View>
          <View
            width="70%"
            backgroundColor="#e0e0e0"
            padding="20px"
            // style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
              }}
            >
              <Heading level={2}>門診記錄 {patientData.currentDate}</Heading>
              <SwitchField // 使用 SwitchField 创建左右滑动的开关
                id="arrived"
                // isChecked={true}
                defaultChecked={
                  patientData.data[patientData.currentDate]?.arrived ?? true
                }
                // onChange={handlePatientData}
                label={<strong style={{ color: "red" }}>報到</strong>}
              />
              <SwitchField // 使用 SwitchField 创建左右滑动的开关
                id="doctorInfo"
                // isChecked={true}
                defaultChecked={
                  patientData.data[patientData.currentDate]?.doctorInfo ?? true
                }
                // onChange={handlePatientData}
                label={<strong>醫師看診：</strong>}
              />
              <br />

              <SwitchField
                id="boneAge"
                defaultChecked={
                  patientData.data[patientData.currentDate]?.boneAge ?? false
                }
                // onChange={handlePatientData}
                label={<strong>骨齡：</strong>}
              />
              <br />
              <SwitchField
                id="daflon"
                defaultChecked={
                  patientData.data[patientData.currentDate]?.daflon ?? false
                }
                // onChange={handlePatientData}
                label={<strong>達菲林12W：</strong>}
              />
              <br />
              <SwitchField
                id="daflon4W"
                defaultChecked={
                  patientData.data[patientData.currentDate]?.daflon4W ?? false
                }
                // onChange={handlePatientData}
                label={<strong>達菲林4W：</strong>}
              />
              <br />
              <SwitchField
                id="leuplin12W"
                defaultChecked={
                  patientData.data[patientData.currentDate]?.leuplin12W ?? false
                }
                // onChange={handlePatientData}
                label={<strong>柳菩林12W：</strong>}
              />
              <br />
              <div style={{ display: "flex", alignItems: "center" }}>
                <SwitchField
                  id="growthHormone"
                  defaultChecked={
                    patientData.data[patientData.currentDate]?.growthHormone ??
                    false
                  }
                  onChange={() =>
                    setGrowthHormoneNumberDisabled(!growthHormoneNumberDisabled)
                  }
                  label={<strong>生長激素帥健：</strong>}
                />
                <Text style={{ marginLeft: "20px" }}>數量：</Text>
                <SelectField
                  // label="數量："
                  id="growthHormoneNumber"
                  options={Array.from({ length: 25 }, (_, i) => i + 1)} // 创建一个包含1到25的数组
                  // onChange={handlPatientInfo}
                  isDisabled={growthHormoneNumberDisabled}
                  defaultValue={
                    patientData.data[patientData.currentDate]
                      ?.growthHormoneNumber ?? 1
                  }
                  // value={
                  //   patientData.data[patientData.currentDate]
                  //     ?.growthHormoneNumber ?? 1
                  // }
                  style={{ marginLeft: "0px" }}
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <SwitchField
                  id="omnitrop"
                  defaultChecked={
                    patientData.data[patientData.currentDate]?.omnitrop ?? false
                  }
                  onChange={() =>
                    setOmnitropNumberDisabled(!omnitropNumberDisabled)
                  }
                  label={<strong>生長激素歐密拓：</strong>}
                />
                <Text style={{ marginLeft: "20px" }}>數量：</Text>
                <SelectField
                  // label="數量："
                  id="omnitropNumber"
                  options={Array.from({ length: 30 }, (_, i) => i + 1)} // 创建一个包含1到25的数组
                  // onChange={handlPatientInfo}
                  isDisabled={omnitropNumberDisabled}
                  defaultValue={
                    patientData.data[patientData.currentDate]?.omnitropNumber ??
                    1
                  }
                  style={{ marginLeft: "0px" }}
                />
              </div>
              <br />
              <div style={{ display: "flex", alignItems: "center" }}>
                <SwitchField
                  id="bloodTest"
                  defaultChecked={
                    patientData.data[patientData.currentDate]?.bloodTest ??
                    false
                  }
                  onChange={() =>
                    setBloodTestTypeDisabled(!bloodTestTypeDisabled)
                  }
                  label={<strong>抽血：</strong>}
                />
                <Text style={{ marginLeft: "20px" }}>種類：</Text>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {/* <label htmlFor="bloodTestType" style={{ marginLeft: "20px" }}>
                    種類：
                  </label> */}
                  <SelectField
                    id="bloodTestType"
                    options={[
                      "PPG",
                      "PPB1",
                      "PPB",
                      "SHOR1",
                      "SHOR2G",
                      "SHOR2B",
                      "OBES1",
                      "OBES2",
                      "OBES3",
                      "GH1",
                      "GH2",
                      "GH3",
                      "PROL",
                      "THY1",
                      "THY2",
                    ]}
                    isDisabled={bloodTestTypeDisabled}
                    defaultValue={
                      patientData.data[patientData.currentDate]
                        ?.bloodTestType ?? "PPG"
                    }
                    style={{ flexGrow: 1 }}
                  />
                </div>
              </div>

              <br />
              <SwitchField
                id="ultrasoundForPelvis"
                defaultChecked={
                  patientData.data[patientData.currentDate]
                    ?.ultrasoundForPelvis ?? false
                }
                // onChange={handlePatientData}
                label={<strong>骨盆超音波：</strong>}
              />
              <div
                style={{
                  display: "flex",
                  // position: "absolute",
                  justifyContent: "flex-end",
                  // bottom: "0",
                  // left: "0",
                  // right: "0",
                  marginTop: "auto",
                  padding: "20px",
                }}
              >
                <input
                  type="button"
                  value="回到上一頁"
                  onClick={() => setPatientData(null)}
                />
                <input
                  type="submit"
                  value={
                    "儲存資料"
                    // patientData.first ? "將資料登入複診資料庫" : "儲存資料"
                  }
                />
              </div>
            </div>
          </View>
        </div>
      </form>
      {/* 右侧部分，占 70% */}
    </Flex>
  );
};

export default PatientDataPage;
